import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir8865SchedulePService {

  constructor(private http: HttpClient) { }

  private postWithParams(url: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Load Schedule P details
   * Action code: 726swn
   */
  loadSchedulePDetails(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=726swn";

    const mergedParams = {
      combination_key: params.combination_key,
      irs_form_no: params.irs_form_no,
      tax_year: globalService.tax_year,
      scenario: globalService.scenario,
      jcd_key: globalService.jcd_key || 250
    };

    return this.postWithParams(url, mergedParams);
  }

  /**
   * Load attribute names for Schedule P
   * Action code: p2kz2b
   */
  loadAttributeNames(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=p2kz2b";

    const mergedParams = {
      tax_year: params.tax_year,
      scenario: params.scenario,
      jcd_key: params.jcd_key,
      irs_form_no: params.irs_form_no
    };

    return this.postWithParams(url, mergedParams);
  }

  /**
   * Get countries for FIR
   * Action code: kbuwei
   */
  getCountriesFIR(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=kbuwei";

    const mergedParams = {
      tax_year: params.tax_year,
      jcd_key: params.jcd_key
    };

    return this.postWithParams(url, mergedParams);
  }

  /**
   * Get states
   * Action code: 6eyqnz
   */
  getStates(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=6eyqnz";

    const mergedParams = {
      tax_year: params.tax_year,
      jcd_key: params.jcd_key
    };

    return this.postWithParams(url, mergedParams);
  }

  /**
   * Save Schedule P data
   * Action code: ze6q6h
   */
  saveScheduleP(
    baseUrl: string,
    scheduleSettings: any,
    scheduleDetails: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=ze6q6h";

    const gp = globalService?.globalParams || {};
    let params = _.merge({}, gp, filterParams);
    params.jsonObj = JSON.stringify(scheduleDetails);
    params.jsonSettings = JSON.stringify(scheduleSettings);
    params.process_name = 'Schedule_P_Save';

    return this.postWithParams(url, params);
  }

  /**
   * Delete Schedule P record
   * Action code: qsz4q9
   */
  deleteSchedule(
    baseUrl: string,
    data: any[],
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=qsz4q9";

    const gp = globalService?.globalParams || {};
    let params = _.merge({}, gp, filterParams);
    params.jsonObj = JSON.stringify(data);

    return this.postWithParams(url, params);
  }
}
